module.exports = __webpack_public_path__ + "img/middleleft1.a47df505.png";